import { useTranslation } from 'next-i18next';
import { type GroupPricingContent } from '../PricingSection1/groupPricingContent';
import { PlanComparisonTable } from './PlanComparisonTable';
export const PlanComparisonSection = ({
  groupPricingContent
}: {
  groupPricingContent: GroupPricingContent;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <section id="plan-comparison" className="flex flex-col items-center gap-xl py-2xl tablet-lg:py-3xl" data-sentry-component="PlanComparisonSection" data-sentry-source-file="PlanComparisonSection.tsx">
      <h2 className="text-display-sm-extrabold">
        {t('common:pricing.comparePlanFeatures')}
      </h2>
      <div className="mx-auto w-full max-w-[1280px] overflow-x-auto">
        <PlanComparisonTable groupPricingContent={groupPricingContent} data-sentry-element="PlanComparisonTable" data-sentry-source-file="PlanComparisonSection.tsx" />
      </div>
    </section>;
};